export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00900.6fd6edf1.png";